import React from 'react';
import TextArea from '../common/TextArea';

const Page7ProductFeedback = ({ 
  productFeedback,
  updateProductFeedback,
  radarUsage,
  setRadarUsage,
  handlePrevious,
  handleNext 
}) => {
  // Helper function to check if a response is selected for question 1
  const isResponseSelected = (questionKey) => {
    return Object.values(productFeedback[questionKey]).some(value => value === true);
  };

  // Update agreement response for question 1
  const updateAgreementResponse = (questionKey, optionKey) => {
    const updatedResponses = { ...productFeedback };
    
    // Reset all options for this question
    Object.keys(updatedResponses[questionKey]).forEach(key => {
      updatedResponses[questionKey][key] = false;
    });
    
    // Set the selected option to true
    updatedResponses[questionKey][optionKey] = true;
    
    updateProductFeedback(updatedResponses);
  };

  return (
    <>
      <div className="questions-grid">
        <div className="question-item full-width">
          <label>Do you believe that using RADAR has helped with digitization of medical records in your critical care unit?</label>
          <div className="rating-options">
            {['Strongly Agree', 'Agree', 'Disagree', 'Strongly Disagree'].map((option, index) => (
              <div key={index} className="rating-option">
                <label 
                  className={`checkbox-label ${productFeedback.digitization[`option${index + 1}`] ? 'selected' : ''}`}
                >
                  <input
                    type="radio"
                    name="digitization"
                    checked={productFeedback.digitization[`option${index + 1}`]}
                    onChange={() => updateAgreementResponse('digitization', `option${index + 1}`)}
                  />
                  <span>{option}</span>
                </label>
              </div>
            ))}
          </div>
        </div>

        <div className="question-item full-width">
          <label>Are you aware that you can get live video coverage and current medical information about patients admitted in your critical care unit via Cloudphysician's mobile app?</label>
          <div className="rating-options">
            {[
              'Yes, I use RADAR app frequently',
              'Yes, I have logged in only few times',
              'No, I wasn\'t aware'
            ].map((option, index) => (
              <div key={index} className="rating-option">
                <label 
                  className={`checkbox-label ${radarUsage === option ? 'selected' : ''}`}
                >
                  <input
                    type="radio"
                    name="radarUsage"
                    value={option}
                    checked={radarUsage === option}
                    onChange={(e) => setRadarUsage(e.target.value)}
                  />
                  <span>{option}</span>
                </label>
              </div>
            ))}
          </div>
        </div>

        <div className="question-item full-width">
          <label>What features would you like to see added in RADAR to improve your experience in providing critical care to patients?</label>
          <TextArea
            value={productFeedback.radarFeatures}
            onChange={(value) => {
              const updatedFeedback = { 
                ...productFeedback, 
                radarFeatures: value 
              };
              updateProductFeedback(updatedFeedback);
            }}
            placeholder="Please provide your suggestions here..."
          />
        </div>
      </div>
      <div className="button-group">
        <button className="nav-button" onClick={handlePrevious}>Previous</button>
        <button 
          className="nav-button" 
          onClick={handleNext}
          disabled={!isResponseSelected('digitization') || !radarUsage || !productFeedback.radarFeatures.trim()}
        >
          Next
        </button>
      </div>
    </>
  );
};

export default Page7ProductFeedback; 